// extracted by mini-css-extract-plugin
module.exports = {"img":"ImageDisplay_img__3ahpY"};